import { type ReactNode, createContext, useContext, useMemo } from 'react';
import handleFacets from '../_tools/axios/cars/helpers/handleFacets';
import type { Facets, FacetsService } from '../_types/Car';
import useLocales from '../hooks/useLocales';
import { useSettingsContext } from './settings';

const AllFacetsContext = createContext<Facets>(undefined);

export const useAllFacetsContext = () => {
    const context = useContext(AllFacetsContext);
    return context;
};

type AllFacetsProviderProps = {
    children: ReactNode;
    rawAllFacets: FacetsService;
};

export function AllFacetsProvider({ children, rawAllFacets }: AllFacetsProviderProps) {
    const { translate } = useLocales();
    const settings = useSettingsContext();

    const memoizedValue = useMemo(
        () => handleFacets(rawAllFacets, translate, settings),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [translate]
    );

    return <AllFacetsContext.Provider value={memoizedValue}>{children}</AllFacetsContext.Provider>;
}
